import { useEffect, useRef } from 'react';

export function useClickOutside<T extends HTMLElement>(handler: () => void) {
  const wrapperRef = useRef<T>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent | TouchEvent) {
      if (!wrapperRef.current || wrapperRef.current.contains(event.target as T)) {
        return;
      }

      // If the click landed inside a higher z-index modal/backdrop, don't close this one.
      // This prevents both modals from closing when only the top one should.
      const target = event.target as HTMLElement;
      const wrapperZ = parseFloat(getComputedStyle(wrapperRef.current).zIndex || '0') || 0;
      const targetModal = target.closest<HTMLElement>('[data-modal-layer]');
      if (targetModal) {
        const targetZ = parseFloat(getComputedStyle(targetModal).zIndex || '0') || 0;
        if (targetZ > wrapperZ) {
          return;
        }
      }

      handler();
    }

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [wrapperRef]);

  return wrapperRef;
}
